module.exports = __webpack_public_path__ + "media/icons/i-6-roles-98570a32.png";